import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Youtube, Mail, MapPin, Phone, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-fp-surface border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_focusagency/artifacts/gtut8c09_FP%20Logo%20Straight%20White.png"
              alt="Focus Pixel"
              className="h-7 mb-6"
            />
            <p className="text-fp-textMuted text-sm leading-relaxed mb-6">
              We build digital growth engines for ambitious brands. Strategy, creative, 
              and technology that delivers measurable results.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/thefocuspixel/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://in.linkedin.com/company/focus-pixel"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all"
                data-testid="footer-youtube"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              {[
                { name: 'About Us', href: '/about' },
                { name: 'Our Work', href: '/portfolio' },
                { name: 'Services', href: '/services' },
                { name: 'Client Portal', href: '/demo' },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-fp-textMuted hover:text-white text-sm transition-colors flex items-center gap-1 group"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                'Branding & Design',
                'Video Production',
                'Performance Marketing',
                'Website & Tech',
              ].map((service) => (
                <li key={service}>
                  <span className="text-fp-textMuted text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-1" />
                <span className="text-fp-textMuted text-sm">
                  Pune, Maharashtra, India
                </span>
              </li>
              <li>
                <a
                  href="tel:+917030771071"
                  className="flex items-center gap-3 text-fp-textMuted hover:text-white text-sm transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4 text-primary" />
                  +91 7030771071
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@focuspixel.in"
                  className="flex items-center gap-3 text-fp-textMuted hover:text-white text-sm transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-primary" />
                  hello@focuspixel.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-fp-textMuted text-sm">
            © {new Date().getFullYear()} Focus Pixel. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-fp-textMuted hover:text-white text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-fp-textMuted hover:text-white text-sm transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
